<template>
  <transition name="charts-checkbox">
    <div :class="classModifiers" v-if="show">
      <label class="charts-checkbox__label-container" :for="name">
        <input
          type="checkbox"
          :name="name"
          :id="name"
          :checked="modelValue || undefined"
          :disabled="disabled"
          @change="onChange"
        />
        <div :style="styleModifiers" :class="tickClassModifiers"></div>
        <div class="charts-checkbox__label">
          <slot></slot>
        </div>
      </label>
    </div>
  </transition>
</template>

<script src="./checkbox.js"></script>
<style src="./checkbox.scss" lang="scss"></style>
